import dayjs from 'dayjs';

import { FetchRemindersResponseType } from './useSearchReminders';

export interface RemindersDataType {
  key: React.Key;
  uuid: string;
  title: string;
  date: string;
  type: string;
  info: string;
  user: string;
  text: string;
}

export const useRemindersTableDataSource = (data: FetchRemindersResponseType | undefined): RemindersDataType[] => {
  if (!data) {
    return [];
  }

  const dataToMap = data?.results ?? data;

  return dataToMap.map((element) => {
    return {
      key: element.uuid,
      uuid: element.uuid,
      title: element.title,
      date: dayjs.unix(element.date).format('DD-MM-YYYY'),
      type: element.type,
      info: element.objectInfo,
      user: `${element.user?.lastName ?? ''} ${element.user?.firstName ?? ''}`,
      text: element.text,
    };
  });
};
